'use strict';

var _toConsumableArray = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Assert = require('@hapi/hoek/lib/assert');

var internals = {};

module.exports = /*#__PURE__*/function () {
  function Topo() {
    _classCallCheck(this, Topo);

    this._items = [];
    this.nodes = [];
  }

  _createClass(Topo, [{
    key: "add",
    value: function add(nodes, options) {
      options = options || {}; // Validate rules

      var before = [].concat(options.before || []);
      var after = [].concat(options.after || []);
      var group = options.group || '?';
      var sort = options.sort || 0; // Used for merging only

      Assert(!before.includes(group), "Item cannot come before itself: ".concat(group));
      Assert(!before.includes('?'), 'Item cannot come before unassociated items');
      Assert(!after.includes(group), "Item cannot come after itself: ".concat(group));
      Assert(!after.includes('?'), 'Item cannot come after unassociated items');

      if (!Array.isArray(nodes)) {
        nodes = [nodes];
      }

      var _iterator = _createForOfIteratorHelper(nodes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          var item = {
            seq: this._items.length,
            sort: sort,
            before: before,
            after: after,
            group: group,
            node: node
          };

          this._items.push(item);
        } // Insert event

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var valid = this._sort();

      Assert(valid, 'item', group !== '?' ? "added into group ".concat(group) : '', 'created a dependencies error');
      return this.nodes;
    }
  }, {
    key: "merge",
    value: function merge(others) {
      if (!Array.isArray(others)) {
        others = [others];
      }

      var _iterator2 = _createForOfIteratorHelper(others),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var other = _step2.value;

          if (other) {
            var _iterator3 = _createForOfIteratorHelper(other._items),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var item = _step3.value;

                this._items.push(Object.assign({}, item)); // Shallow cloned

              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } // Sort items

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._items.sort(internals.mergeSort);

      for (var i = 0; i < this._items.length; ++i) {
        this._items[i].seq = i;
      }

      var valid = this._sort();

      Assert(valid, 'merge created a dependencies error');
      return this.nodes;
    }
  }, {
    key: "_sort",
    value: function _sort() {
      // Construct graph
      var graph = {};
      var graphAfters = Object.create(null); // A prototype can bungle lookups w/ false positives

      var groups = Object.create(null);

      var _iterator4 = _createForOfIteratorHelper(this._items),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          var seq = item.seq; // Unique across all items

          var _group2 = item.group; // Determine Groups

          groups[_group2] = groups[_group2] || [];

          groups[_group2].push(seq); // Build intermediary graph using 'before'


          graph[seq] = item.before; // Build second intermediary graph with 'after'

          var _iterator8 = _createForOfIteratorHelper(item.after),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var after = _step8.value;
              graphAfters[after] = graphAfters[after] || [];
              graphAfters[after].push(seq);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        } // Expand intermediary graph

      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      for (var node in graph) {
        var expandedGroups = [];

        for (var graphNodeItem in graph[node]) {
          var group = graph[node][graphNodeItem];
          groups[group] = groups[group] || [];
          expandedGroups.push.apply(expandedGroups, _toConsumableArray(groups[group]));
        }

        graph[node] = expandedGroups;
      } // Merge intermediary graph using graphAfters into final graph


      for (var _group in graphAfters) {
        if (groups[_group]) {
          var _iterator5 = _createForOfIteratorHelper(groups[_group]),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _graph$_node;

              var _node = _step5.value;

              (_graph$_node = graph[_node]).push.apply(_graph$_node, _toConsumableArray(graphAfters[_group]));
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } // Compile ancestors


      var ancestors = {};

      for (var _node2 in graph) {
        var children = graph[_node2];

        var _iterator6 = _createForOfIteratorHelper(children),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var child = _step6.value;
            ancestors[child] = ancestors[child] || [];
            ancestors[child].push(_node2);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      } // Topo sort


      var visited = {};
      var sorted = [];

      for (var i = 0; i < this._items.length; ++i) {
        // Looping through item.seq values out of order
        var next = i;

        if (ancestors[i]) {
          next = null;

          for (var j = 0; j < this._items.length; ++j) {
            // As above, these are item.seq values
            if (visited[j] === true) {
              continue;
            }

            if (!ancestors[j]) {
              ancestors[j] = [];
            }

            var shouldSeeCount = ancestors[j].length;
            var seenCount = 0;

            for (var k = 0; k < shouldSeeCount; ++k) {
              if (visited[ancestors[j][k]]) {
                ++seenCount;
              }
            }

            if (seenCount === shouldSeeCount) {
              next = j;
              break;
            }
          }
        }

        if (next !== null) {
          visited[next] = true;
          sorted.push(next);
        }
      }

      if (sorted.length !== this._items.length) {
        return false;
      }

      var seqIndex = {};

      var _iterator7 = _createForOfIteratorHelper(this._items),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _item = _step7.value;
          seqIndex[_item.seq] = _item;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      this._items = [];
      this.nodes = [];

      for (var _i = 0, _sorted = sorted; _i < _sorted.length; _i++) {
        var value = _sorted[_i];
        var sortedItem = seqIndex[value];
        this.nodes.push(sortedItem.node);

        this._items.push(sortedItem);
      }

      return true;
    }
  }]);

  return Topo;
}();

internals.mergeSort = function (a, b) {
  return a.sort === b.sort ? 0 : a.sort < b.sort ? -1 : 1;
};